module.exports = __webpack_public_path__ + "img/prize-03.5401c96f.jpg";